import { Fragment } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import { Check, Slash } from 'react-feather';
import { H4, Span } from '../../../../../Themes/Components/AbstractElements';

const MovimentacoesTimeline = ({ movimentacoes }) => {
  const getIcon = (tipoMovimentacao) => {
    switch (tipoMovimentacao) {
      case 'Criação':
        return <Check />;
      case 'Extinção':
        return <Slash />;
      default:
        return <span style={{ width: '12px', height: '12px', borderRadius: '50%', background: 'white' }}></span>;
    }
  };

  const getIconClassName = (tipoMovimentacao) => {
    if (tipoMovimentacao === 'Criação' || tipoMovimentacao === 'Extinção') return '';

    return 'vertical-timeline-element-icon--sem-tipo';
  };

  if (!movimentacoes || movimentacoes.length === 0) {
    return (
      <p style={{ textAlign: 'center', fontSize: '14px', color: 'black', opacity: 0.87 }}>
        Nenhum registro encontrado.
      </p>
    );
  }

  return (
    <Fragment>
      <VerticalTimeline layout='1-column-left' animate={false}>
        {movimentacoes.map((movimentacao) => (
          <VerticalTimelineElement
            key={movimentacao.id}
            className='vertical-timeline-element--work'
            icon={getIcon(movimentacao.tipo_movimentacao)}
            iconClassName={getIconClassName(movimentacao.tipo_movimentacao)}
          >
            <H4 attrH4={{ className: 'vertical-timeline-element-subtitle' }}>{movimentacao.descricao}</H4>
            <div className='pb-2 mb-3 border-bottom'>
              <Span>{movimentacao.data_evento}</Span>
            </div>

            <div className='row'>
              <div className='col-sm-2'>
                <H4>Número do Processo</H4>
                <Span>{movimentacao.processo_numero}</Span>
              </div>
              <div className='col-sm-2'>
                <H4>Tipo do Documento</H4>
                <Span>{movimentacao.documento_tipo}</Span>
              </div>
              <div className='col-sm-2'>
                <H4>Número do Documento</H4>
                <Span>{movimentacao.documento_numero}</Span>
              </div>
              <div className='col-sm-2'>
                <H4>Versão do Documento</H4>
                <Span>{movimentacao.documento_versao}</Span>
              </div>
              <div className='col-sm-2'>
                <H4>Número do Item do Documento</H4>
                <Span>{movimentacao.documento_numero_item}</Span>
              </div>
              <div className='col-sm-2'>
                <H4>Chave de Acesso do Documento</H4>
                <Span>{movimentacao.documento_chave_acesso}</Span>
              </div>
            </div>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </Fragment>
  );
};

export default MovimentacoesTimeline;
